import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type BadgeSeverity = 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'contrast';

@Component({
  selector: 'app-badge',
  template: `
    <span [class]="classes()" [attr.aria-label]="ariaLabel() || value()">
      {{ value() }}
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UiBadge {
  readonly value = input<string>('');
  readonly severity = input<BadgeSeverity>('primary');
  readonly ariaLabel = input<string>('');

  protected classes(): string {
    const base =
      'inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full text-xs font-semibold align-middle leading-none';
    const variants: Record<BadgeSeverity, string> = {
      primary: 'bg-accent-600 text-white',
      secondary: 'bg-slate-500 text-white',
      success: 'bg-teal-600 text-white',
      info: 'bg-sky-600 text-white',
      warning: 'bg-amber-600 text-white',
      danger: 'bg-rose-600 text-white',
      contrast: 'bg-slate-800 text-white',
    };
    return `${base} ${variants[this.severity()]}`;
  }
}
